import React, { useEffect } from "react";
import Path from "../components/program/Path";
import TopHighlight from "../components/program/TopHighlight";
import Info from "../components/program/Info";
import CourseOverview from "../components/program/CourseOverview";
import Learnings from "../components/program/Learnings";
import CourseOffers from "../components/program/CourseOffers";
import Specialization from "../components/program/Specialization";
import Achievements from "../components/program/Achievements";
import Placement from "../components/program/Placement";
import CareerOpportunity from "../components/program/CareerOpportunity";
import Certificate from "../components/program/Certificate";
import Help from "../components/program/Help";
import FeeDetails from "../components/program/FeeDetails";
import HowtoApply from "../components/program/HowToApply";
import TalkToAnExpert from "../components/program/TalkToAnExpert";
import UniversityDetails from "../components/program/UniversityDetails";
import FrequentlyAskedQ from "../components/program/FrequentlyAskedQ";
import { useState } from "react";
import { useParams } from "react-router-dom";

export default function CourseDetails() {
  const fetchUniversityData = async (uid) => {
    const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL_DEV;
    try {
      const res = await fetch(`${apiUrl}/university/${uid}`);
      // ${uid}
      if (!res.ok) {
        return;
      }

      const data = await res.json();
      setUniversityData(data);
      // console.log("University data:", data);
    } catch (error) {
      console.error("Error fetching university data:", error);
    }
  };

  const { id } = useParams();
  const [data, setProgramData] = useState(null);
  const [university_data, setUniversityData] = useState(null);

  useEffect(() => {
    const fetchProgramData = async () => {
      const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL_PROD;
      try {
        const res = await fetch(`${apiUrl}/program/${id}`);

        if (!res.ok) {
          console.error("Failed to fetch program data");
          setProgramData(null);
          return;
        }

        const program = await res.json();
        setProgramData(program);

      } catch (error) {
        console.error("Error fetching program data:", error);
        setProgramData(null);
      }
    };
    fetchUniversityData(id?.slice(0,3));
    fetchProgramData();
  }, [id]);
  return (
    <div className="w-full max-w-[1380px] mx-auto px-4 sm:px-6 lg:px-8">
      {data && (
        <section className="space-y-8 md:space-y-12">
          {/* Path */}
          <div className="w-full">
            <Path data={data} />
          </div>
          {/* Top Portion */}
          <div className="w-full">
            <TopHighlight universityData={university_data} data={data} />
          </div>
          {/* Information */}
          <div className="w-full">
            <Info data={data} />
          </div>
          {/* Program Overview */}
          <div className="w-full">
            <CourseOverview data={data} />
          </div>
          {/* What will you learn? */}
          <div className="w-full">
            <Learnings data={data} />
          </div>
          {/* What Does This Course Offer? */}
          <div className="w-full">
            <CourseOffers data={data} />
          </div>
          {/* Specialization */}
          <div className="w-full">
            <Specialization data={data} />
          </div>
          {/* Learner's Achievements */}
          <div className="w-full">
            <Achievements data={data} />
          </div>
          {/* Placement Overview */}
          <div className="w-full">
            <Placement data={data} />
          </div>
          {/* Career Opportunities */}
          <div className="w-full">
            <CareerOpportunity data={data} />
          </div>
          {/* Certificate */}
          <div className="w-full">
            <Certificate data={data} />
          </div>
          {/* University details */}
          <div className="w-full">
            <UniversityDetails universityData={university_data} data={data} />
          </div>
          {/* How Mentorsity Can Help */}
          <div className="w-full">
            <Help data={data} />
          </div>
          {/* Instructors */}
          {/* <div className="w-full">
            <Instructors data={data} />
          </div> */}
          {/* Fee Details */}
          <div className="w-full">
            <FeeDetails data={data} />
          </div>
          {/* How to Apply */}
          <div className="w-full">
            <HowtoApply data={data} />
          </div>
          {/* Talk to an Expert */}
          <div className="w-full">
            <TalkToAnExpert />
          </div>
          {/* Frequently Asked Questions */}
          <div className="w-full">
            <FrequentlyAskedQ data={data} />
          </div>
        </section>
      )}
    </div>
  );
}
